import React from 'react';
import { workItemShareLabel, WORK_ITEM_SHARE_KIND } from '../../utils/workItemShare';

const WorkItemShareCard = ({ share, typeLabel, onOpen, onCopyLink }) => {
  const kind = typeLabel
    || (share?.kind === WORK_ITEM_SHARE_KIND.TASK ? 'Task' : 'Workflow');
  const title = String(share?.title || '').trim() || workItemShareLabel(share);

  return (
    <div className="w-full rounded-xl border border-primary-200 dark:border-primary-800/70 bg-transparent px-3.5 py-3">
      <button
        type="button"
        onClick={onOpen}
        className="w-full text-left"
      >
        <p className="text-[10px] font-semibold uppercase tracking-wide text-primary-600 dark:text-primary-300">
          {kind}
        </p>
        <p className="mt-1 text-sm font-semibold text-gray-900 dark:text-white break-words">
          {title}
        </p>
      </button>
      <div className="mt-2 flex items-center justify-between gap-2">
        <button
          type="button"
          onClick={onOpen}
          className="text-[11px] text-gray-500 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-300"
        >
          Open to view
        </button>
        {onCopyLink ? (
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              onCopyLink();
            }}
            className="inline-flex items-center gap-1 text-[11px] font-medium text-primary-600 dark:text-primary-300 hover:text-primary-700 dark:hover:text-primary-200"
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
            </svg>
            Copy link
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default WorkItemShareCard;
